import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Container, SliderTitle } from "./ProductsSlider.style";
import ProductCard from "./ProductCard";
import axios from 'axios';
import { useParams } from 'react-router-dom';

const formatCategoryName = (category) => {
  return category
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

const ProductsSlider = () => {
  const [productsByCategory, setProductsByCategory] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentSlides, setCurrentSlides] = useState({});
  const { lineId } = useParams();

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/products`);
        // Filter products by line if lineId is provided
        const filteredProducts = lineId 
          ? response.data.filter(product => product.lineId === lineId)
          : response.data;
        
        // Group products by category
        const groupedProducts = filteredProducts.reduce((acc, product) => {
          if (!acc[product.category]) {
            acc[product.category] = [];
          }
          acc[product.category].push(product);
          return acc;
        }, {});
        
        setProductsByCategory(groupedProducts);
      } catch (err) {
        setError('Failed to fetch products');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [lineId]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;
  if (Object.keys(productsByCategory).length === 0) return <div>No products found</div>;

  const getSettings = (productsCount, category) => ({
    dots: false,
    infinite: productsCount > 1,
    speed: 400,
    slidesToShow: Math.min(productsCount, 4),
    slidesToScroll: 1,
    initialSlide: 0,
    centerMode: false,
    variableWidth: false,
    prevArrow: currentSlides[category] === 0 ? <></> : undefined,
    afterChange: (current) => setCurrentSlides(prev => ({ ...prev, [category]: current })),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: Math.min(productsCount, 3),
          slidesToScroll: 1,
          infinite: productsCount > 1,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: productsCount > 1,
          initialSlide: 0
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: productsCount > 1
        }
      }
    ]
  });

  return (
    <Container>
      {Object.entries(productsByCategory).map(([category, products]) => (
        <div key={category}>
          <SliderTitle>{formatCategoryName(category)}</SliderTitle>
          <div className={`slider-container ${currentSlides[category] === 0 ? 'hide-left-arrow' : ''}`}>
            <Slider {...getSettings(products.length, category)}>
              {products.map((product) => (
                <ProductCard 
                  key={product.id} 
                  product={product} 
                  isSingleItem={products.length === 1}
                />
              ))}
            </Slider>
          </div>
        </div>
      ))}
    </Container>
  );
};

export default ProductsSlider;
